import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { PAYMENT_METHODS } from '@config/payment-methods.config';
import { PAYMENT_METHOD_PICKER_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { PaymentMethodPickerBlockScenarioContent } from '@front-platform/content-builder';

import {
  PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM,
  PaymentMethodPickerBlockDataSource,
  PaymentMethodPickerBlockViewModel,
} from './payment-method-picker-block-view-model';

export function toPaymentMethodPickerPreviewViewModel(
  content: PaymentMethodPickerBlockScenarioContent,
): PaymentMethodPickerBlockViewModel {
  const isUnique = content.availablePaymentMethodHandles.length === 1;
  return {
    availablePaymentMethods: content.availablePaymentMethodHandles
      .map((handle, position) => {
        const method = PAYMENT_METHODS.find(entry => entry.handle === handle);
        if (!method) {
          return null;
        }
        return {
          ...method,
          data: {
            handle: method.handle,
            position,
            isUnique,
          },
        };
      })
      .filter((method): method is NonNullable<typeof method> => method !== null),
    orderFinalPrice: content.orderFinalPrice,
    remainingMinutes: content.remainingMinutes,
    isRetryInProgress: content.isRetryInProgress,
  };
}

@Injectable()
export class PaymentMethodPickerBlockPreviewDataSource implements PaymentMethodPickerBlockDataSource {
  readonly vm$: Observable<PaymentMethodPickerBlockViewModel> = previewScenarioForBloc$(
    PAYMENT_METHOD_PICKER_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<PaymentMethodPickerBlockScenarioContent>(
        scenario,
        PAYMENT_METHOD_PICKER_BLOCK_COMPONENT,
      );
      return content
        ? toPaymentMethodPickerPreviewViewModel(content)
        : PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM;
    }),
  );
}
